import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router';
import * as ReactDOM from 'react-dom/client';
import {
  buildSentryTracePropagationTargets,
  hydratePortalSentryUserFromStorage,
  initPortalSentry,
  setPortalSentryTag,
} from '@admin-panel/observability';
import { ensureDeviceFingerprint, getDeviceFingerprint } from '@admin-panel/utils';
import App from './app/Application';
import { registerRiderServiceWorker } from './registerRiderServiceWorker';

const tracePropagationTargets = buildSentryTracePropagationTargets(
  import.meta.env.VITE_GATEWAY_API_URL,
);

initPortalSentry(tracePropagationTargets);

const bootstrap = async () => {
  await ensureDeviceFingerprint();
  setPortalSentryTag('device_id', getDeviceFingerprint());
  hydratePortalSentryUserFromStorage();
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
};

void bootstrap();

void registerRiderServiceWorker({
  apiKey: import.meta.env.VITE_FIREBASE_NOTIFICATIONS_API_KEY as string,
  authDomain: import.meta.env.VITE_FIREBASE_NOTIFICATIONS_AUTH_DOMAIN as string,
  projectId: import.meta.env.VITE_FIREBASE_NOTIFICATIONS_PROJECT_ID as string,
  storageBucket: import.meta.env.VITE_FIREBASE_NOTIFICATIONS_STORAGE_BUCKET as string,
  messagingSenderId: import.meta.env.VITE_FIREBASE_NOTIFICATIONS_MESSAGING_SENDER_ID as string,
  appId: import.meta.env.VITE_FIREBASE_NOTIFICATIONS_APP_ID as string,
  measurementId: import.meta.env.VITE_FIREBASE_NOTIFICATIONS_MEASUREMENT_ID as string,
  vapidKey: import.meta.env.VITE_FIREBASE_NOTIFICATIONS_VAPID_KEY as string,
});
